var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCards28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.454 5.885c-.375 1.119-.184 2.482.2 5.208l.848 6.04c.383 2.727.575 4.09 1.244 5.062a5 5 0 0 0 2.528 1.904c1.118.376 2.498.182 5.257-.206a301.894 301.894 0 0 0 1.413-.202c1.805-.269 2.857-.494 3.64-1.01l.057-.039a5 5 0 0 0 1.905-2.527c.375-1.118.184-2.482-.2-5.208l-.848-6.04c-.384-2.727-.575-4.09-1.244-5.062a5 5 0 0 0-2.528-1.904c-1.118-.376-2.498-.182-5.257.206-2.76.388-4.139.582-5.11 1.25a5 5 0 0 0-1.905 2.528Zm19 2.456.014.108.85 6.04.015.109c.178 1.27.336 2.395.392 3.338.06 1.003.026 2.058-.335 3.133a8 8 0 0 1-3.047 4.044 6.783 6.783 0 0 1-1.308.699l.712.1c1.844.26 2.765.389 3.545.252a5 5 0 0 0 3.626-2.733c.347-.711.476-1.633.736-3.476l.556-3.961c.26-1.843.389-2.765.251-3.545a5 5 0 0 0-2.732-3.626c-.69-.336-1.576-.468-3.308-.712l.032.23Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards28);
export default __webpack_public_path__ + "static/media/cards_28.2c6e868c.svg";
export { ForwardRef as ReactComponent };